"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
const base_1 = __importDefault(require("../crypto/base"));
// a mock storage class that just use js objects
// sql.js would be perfect for the job
class BitcoinLikeStorage {
    constructor() {
        this.txs = [];
        // indexe: address + hash -> tx
        this.primaryIndex = {};
        // indexe: account + index -> tx
        this.accountIndex = {};
        // accounting
        this.unspentUtxos = {};
        this.addressCache = {};
        // only needed to handle the case when the input
        // is seen before the output (typically explorer
        // returning unordered tx within the same block)
        this.spentUtxos = {};
    }
    hasTx(txFilter) {
        const index = `${txFilter.account}-${txFilter.index}`;
        return !!this.accountIndex[index] && this.accountIndex[index].length > 0;
    }
    txsSize() {
        return this.txs.length;
    }
    hasPendingTx(txFilter) {
        const index = `${txFilter.account}-${txFilter.index}`;
        return (!!this.accountIndex[index] &&
            this.accountIndex[index].map(i => this.txs[i]).some(tx => !tx.block));
    }
    getHighestBlockHeightAndHash() {
        let highestBlock = null;
        this.txs.forEach(tx => {
            if (!!tx.block && (!highestBlock || tx.block.height > highestBlock.height)) {
                highestBlock = tx.block;
            }
        });
        return highestBlock;
    }
    getLastConfirmedTxBlock(txFilter) {
        if (typeof this.accountIndex[`${txFilter.account}-${txFilter.index}`] === "undefined") {
            return null;
        }
        let lastConfirmedTxBlock = null;
        this.accountIndex[`${txFilter.account}-${txFilter.index}`]
            .map(i => this.txs[i])
            .forEach(tx => {
            if (!!tx.block &&
                (!lastConfirmedTxBlock || tx.block.height > lastConfirmedTxBlock.height)) {
                lastConfirmedTxBlock = tx.block;
            }
        });
        return lastConfirmedTxBlock;
    }
    getLastUnconfirmedTx() {
        const tx = (0, lodash_1.findLast)(this.txs, t => {
            return !t.block;
        });
        return tx;
    }
    getTx(address, txId) {
        const index = `${address}-${txId}`;
        return this.txs[this.primaryIndex[index]];
    }
    // TODO: only expose unspentUtxos
    getAddressUnspentUtxos(address) {
        const indexAddress = address.address;
        return this.unspentUtxos[indexAddress];
    }
    appendTxs(txs) {
        const lastLength = this.txs.length;
        txs.forEach(tx => {
            const indexAddress = tx.address;
            const index = `${indexAddress}-${tx.id}`;
            // we reject already seen tx
            if (this.txs[this.primaryIndex[index]]) {
                return;
            }
            const idx = this.txs.push(tx) - 1;
            this.primaryIndex[index] = idx;
            this.accountIndex[`${tx.account}-${tx.index}`] =
                this.accountIndex[`${tx.account}-${tx.index}`] || [];
            this.accountIndex[`${tx.account}-${tx.index}`].push(idx);
            this.unspentUtxos[indexAddress] = this.unspentUtxos[indexAddress] || [];
            this.spentUtxos[indexAddress] = this.spentUtxos[indexAddress] || [];
            tx.outputs.forEach(output => {
                if (output.address === tx.address) {
                    this.unspentUtxos[indexAddress].push(output);
                }
            });
            tx.inputs.forEach(input => {
                if (input.address === tx.address) {
                    this.spentUtxos[indexAddress].push(input);
                }
            });
            this.unspentUtxos[indexAddress] = this.unspentUtxos[indexAddress].filter(output => {
                const matchIndex = (0, lodash_1.findIndex)(this.spentUtxos[indexAddress], (input) => input.output_hash === output.output_hash && input.output_index === output.output_index);
                if (matchIndex > -1) {
                    this.spentUtxos[indexAddress].splice(matchIndex, 1);
                    return false;
                }
                return true;
            });
        });
        return this.txs.length - lastLength;
    }
    getUniquesAddresses(addressesFilter) {
        // TODO: to speed up, create more useful indexes in appendTxs
        return (0, lodash_1.uniqBy)((0, lodash_1.filter)(this.txs, t => (typeof addressesFilter.account === "undefined" ||
            addressesFilter.account === t.account) &&
            (typeof addressesFilter.index === "undefined" || addressesFilter.index === t.index)).map((tx) => ({
            address: tx.address,
            account: tx.account,
            index: tx.index,
        })), "address");
    }
    removeTxs(txsFilter) {
        const newTxs = [];
        this.primaryIndex = {};
        this.accountIndex = {};
        this.txs.forEach((tx) => {
            // clean
            const indexAddress = tx.address;
            const index = `${indexAddress}-${tx.id}`;
            if (tx.account !== txsFilter.account || tx.index !== txsFilter.index) {
                this.primaryIndex[index] = newTxs.push(tx) - 1;
                return;
            }
            delete this.unspentUtxos[indexAddress];
            delete this.spentUtxos[indexAddress];
        });
        this.txs = newTxs;
        this.createAccountIndex();
    }
    // We are a bit ugly because we can't rely undo unspentUTXO
    // So we clean the address and rebuild without the pendings
    removePendingTxs(txsFilter) {
        const newTxs = [];
        const txsToReAdd = [];
        this.primaryIndex = {};
        this.accountIndex = {};
        this.txs.forEach((tx) => {
            // clean
            const indexAddress = tx.address;
            const index = `${indexAddress}-${tx.id}`;
            if (tx.account !== txsFilter.account || tx.index !== txsFilter.index) {
                this.primaryIndex[index] = newTxs.push(tx) - 1;
                return;
            }
            if (tx.block) {
                txsToReAdd.push(tx);
            }
            delete this.unspentUtxos[indexAddress];
            delete this.spentUtxos[indexAddress];
        });
        this.txs = newTxs;
        this.createAccountIndex();
        this.appendTxs(txsToReAdd);
    }
    addAddress(key, address) {
        if (!this.addressCache) {
            this.addressCache = {};
        }
        this.addressCache[key] = address;
    }
    exportSync() {
        return {
            txs: this.txs,
            addressCache: this.addressCache,
        };
    }
    loadSync(data) {
        this.txs = [];
        this.primaryIndex = {};
        this.accountIndex = {};
        this.unspentUtxos = {};
        this.spentUtxos = {};
        data.txs.forEach(tx => {
            // migration from the field "hash" to "id" to adapt old data format
            if (!tx.id && tx.hash) {
                tx.id = tx.hash;
            }
        });
        this.appendTxs(data.txs);
        this.addressCache = data.addressCache;
        base_1.default.addressCache = Object.assign(Object.assign({}, base_1.default.addressCache), this.addressCache);
    }
    export() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.exportSync();
        });
    }
    load(data) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.loadSync(data);
        });
    }
    createAccountIndex() {
        this.txs.forEach((tx, idx) => {
            if (typeof this.accountIndex[`${tx.account}-${tx.index}`] === "undefined") {
                this.accountIndex[`${tx.account}-${tx.index}`] = [];
            }
            this.accountIndex[`${tx.account}-${tx.index}`].push(idx);
        });
    }
}
exports.default = BitcoinLikeStorage;
//# sourceMappingURL=index.js.map